import { Button, Col, Form, Modal, notification, Row, Select } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSetDatenlieferantLandwirtMutation } from "store/masterdata";
import ConfirmationModal from "views/App/components/Modals/ConfirmationModal";
import SearchTHsModal from "./Modals/SearchTHsModal";

interface Props {
  visible: boolean;
  kundennummer: number;
  datenlieferant: number;
  onClose(): void;
  onSuccess(): void;
}

function ChangeTHsModal({
  visible,
  kundennummer,
  datenlieferant,
  onClose,
  onSuccess,
}: Props): JSX.Element {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  const [tHsSeachModalVisible, setTHsSeachModalVisible] = useState(false);

  const [confirmationModalVisible, setConfirmationModalVisible] =
    useState(false);

  const [setDatenlieferantLandwirt, { isLoading }] =
    useSetDatenlieferantLandwirtMutation();

  const handleSubmit = (values: { option: number }) => {
    if (values.option === 0) {
      setTHsSeachModalVisible(true);
    }
    if (values.option === 1) {
      setConfirmationModalVisible(true);
    }
  };

  const lwOptions = [
    {
      label: t("masterdata.lw_details.add_th_1"),
      value: 0,
    },
  ];

  const thOptions = [
    {
      label: t("masterdata.lw_details.farmer_alone"),
      value: 1,
    },
    {
      label: t("masterdata.lw_details.change_th"),
      value: 0,
    },
  ];

  const confirmSetDatenlieferantLandwirt = async () => {
    try {
      const response = await setDatenlieferantLandwirt({
        kundennummer,
      }).unwrap();
      if (!response.hasErrors) {
        notification.success({
          message: t(
            "masterdata.lw_details.set_datenlieferant_landwirt_success"
          ),
        });
        onClose();
        onSuccess();
      }
    } catch (error) {
      console.error("Error", error);
      onClose();
    }
  };

  return (
    <Modal
      footer={null}
      title={t("masterdata.lw_details.change_data_supplier")}
      visible={visible}
      onCancel={onClose}
      destroyOnClose
    >
      <Form
        id="change-ths-form"
        form={form}
        onFinish={handleSubmit}
        layout="vertical"
        initialValues={{
          option: datenlieferant === 1 ? 0 : 1,
        }}
      >
        <Form.Item name="option" rules={[{ required: true }]}>
          <Select options={datenlieferant === 1 ? lwOptions : thOptions} />
        </Form.Item>
        <Row gutter={20}>
          <Col span={12}>
            <Button onClick={onClose} block>
              {t("abort")}
            </Button>
          </Col>
          <Col span={12}>
            <Button type="primary" htmlType="submit" block>
              {t("confirm")}
            </Button>
          </Col>
        </Row>
      </Form>
      <ConfirmationModal
        visible={confirmationModalVisible}
        isLoading={isLoading}
        title={t("masterdata.lw_details.remove_th")}
        description={t("masterdata.lw_details.remove_th_confirmation")}
        onClose={() => setConfirmationModalVisible(false)}
        onConfirm={confirmSetDatenlieferantLandwirt}
      />
      <SearchTHsModal
        kundennummer={kundennummer}
        visible={tHsSeachModalVisible}
        onClose={() => setTHsSeachModalVisible(false)}
        onSuccess={() => {
          onSuccess();
          onClose();
        }}
      />
    </Modal>
  );
}

export default ChangeTHsModal;
